import React from "react";
import {
  AiFillFilePdf,
  AiFillFileText,
  AiFillFileWord,
  AiFillFileZip,
  AiFillFolder,
  AiFillFile,
} from "react-icons/ai";

import { EntryType } from "../../types";

const iconList = {
  [EntryType.epub]: { icon: AiFillFileZip, color: "#000" },
  [EntryType.doc]: { icon: AiFillFileWord, color: "#1c95ff" },
  [EntryType.pdf]: { icon: AiFillFilePdf, color: "#f00" },
  [EntryType.folder]: { icon: AiFillFolder, color: "#3f5a93" },
  [EntryType.txt]: { icon: AiFillFileText, color: "#000" },
  [EntryType.unknown]: { icon: AiFillFile, color: "#3f5a93" },
};

interface IProps {
  type: EntryType;
}

export const FileIcon: React.FC<IProps> = ({ type }) => {
  const { icon: Icon, color } = iconList[type];

  return (
    <Icon display="block" size={26} fill={color} />
  );
};
